export default __webpack_public_path__ + "static/media/instagram.6d053cb7.svg";